<script lang="ts">
  import type { ComponentProps } from "svelte";
  import { type Task } from "../../lib/tasks";
  import SettlementStatus from "./elements/SettlementStatus.svelte";

  type LineProps = Omit<ComponentProps<typeof SettlementStatus>, "showButtonRow">;

  let { task }: { task: Task } = $props();

  let lineProps = $derived(task.taskLine![1] as LineProps);
</script>

<form action={task.path} data-turbo-frame="task-modal" class="w-full rounded-lg overflow-clip shadow">
  <SettlementStatus {...lineProps} showButtonRow={true} />
</form>
